import { useState, useEffect } from 'react';
import { fetchProductList } from '@/api/product';
import type { MhProduct } from '@/types/mh';

export function useProductList() {
  const [products, setProducts] = useState<MhProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await fetchProductList();
      if (cancelled) {
        return;
      }
      if (res.code === 0 && Array.isArray(res.data)) {
        setProducts(res.data);
        setError('');
      } else {
        setProducts([]);
        setError(res.msg || '加载失败');
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { products, loading, error };
}
